<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Privacy Policy
        </v-card-title>
        <v-card-text class="pt-5">
          {{ text }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            text
            @click="closeDialog"
          >
            No
          </v-btn>
          <v-btn
            color="red"
            text
            @click="archiveCampaign"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ConfirmationDialog',
    props: {
      text: {
        type: String,
        default: 'confirm?'
      },
      dialog: {
        type: Boolean,
        default: false
      },
      archivedCampaignId: {
        type: String,
        default: ''
      }
    },
    methods: {
      closeDialog () {
        this.$emit('closeDialog')
      },
      archiveCampaign () {
        this.$emit('archiveCampaign', this.archivedCampaignId, true)
      }
    }
  }
</script>

<style scoped>

</style>
